import axios from "../../../util/axios";
// 通用接口，有数据权限限制
export default {
    /** 查询客户列表 */
    queryList: (data) => axios.get({url: "/basedata/partner/customer/queryList", data}),
    /** 保存客户信息 */
    saveCustomer: (data) => axios.post({url: "/basedata/partner/customer/saveCustomer", data}),
    /** 查询明细 */
    findById: (id) => axios.get({url: "/basedata/partner/customer/findById", data:{id}}),
    /** 删除客户 */
    delete: (id) => axios.del({url: "/basedata/partner/customer/delete", data:{id}}),
    /** 批量修改分类 */
    updateCategoryBatch: (data) => axios.get({url: "/basedata/partner/customer/updateCategoryBatch", data}),
    /**导出模板*/
    exportTemp: () => axios.get({url: "/basedata/partner/customer/exportTemp", }),
    /** 导入客户（异步，formData：file） */
    importExcel: (formData) => axios.post({url: "/basedata/partner/customer/uploadCustomerByTemplate", data: formData}),
    /** 查询客户导入状态（前端每5秒轮询） */
    importStatus: () => axios.get({url: "/basedata/partner/customer/importStatus"}),
}

